import NewUploadModal from "./NewUploadModal";

export default NewUploadModal;
